import React from "react";
import { toast } from "react-toastify";

let toastCssLoaded = false;
function ensureToastCss() {
  if (toastCssLoaded) return;
  toastCssLoaded = true;
  import("react-toastify/dist/ReactToastify.css");
}

const GlobalToast = (ToastMessage, type) => {
  ensureToastCss();
  if (type === "error") {
    return toast.error(ToastMessage, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  else if (type === "info") {
    return toast.info(ToastMessage, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    })
  }
  else if (type === "warning") {
    return toast.warning(ToastMessage, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    })
  }
  else {
    return toast.success(ToastMessage, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    })
  }
};

export default GlobalToast;


